import React from 'react';

interface AlyzeLogoSolidProps {
  className?: string;
  color?: string;
}

export const AlyzeLogoSolid: React.FC<AlyzeLogoSolidProps> = ({ 
  className = '', 
  color = '#F2F2F2' 
}) => {
  return (
    <svg 
      width="120" 
      height="24" 
      viewBox="0 0 120 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M11.7513 5.05061L5.1549 22.357C4.91394 23.059 4.2599 23.5286 3.5327 23.5286H0L8.16265 1.18915C8.42083 0.473906 9.08778 0 9.83219 0H14.5439C15.2926 0 15.9596 0.478294 16.2134 1.19354L24.3417 23.533H20.8133C20.0818 23.533 19.432 23.0634 19.191 22.3614L12.5904 5.05061C12.4527 4.64253 11.889 4.64253 11.7513 5.05061Z" fill={color}/>
      <path d="M31.7852 0H36.5313V19.2064H46.3764V23.533H31.7852V0Z" fill={color}/>
      <path d="M71.2039 0L62.2926 13.8091V23.533H57.5852V13.8091L48.6738 0H52.8261C53.6351 0 54.3838 0.42125 54.8141 1.11895L59.5817 8.8287C59.7582 9.10953 60.1626 9.10953 60.3348 8.8287L65.068 1.12772C65.4983 0.430026 66.2513 0.00438802 67.0602 0.00438802H71.2083L71.2039 0Z" fill={color}/>
      <path d="M96.4293 0V4.32659L83.7184 19.2064H96.4293V23.533H78.1289V19.2064L90.844 4.32659H78.1289V0H96.4293Z" fill={color}/>
      <path d="M108.881 4.32659V9.60538H117.874L117.272 12.5366C117.104 13.3484 116.403 13.932 115.589 13.932H108.881V19.2108H120V23.5373H104.174V0H120V4.32659H108.881Z" fill={color}/>
    </svg>
  );
};
